import { fetchFactory } from 'isotope-client'

export const getCountries = () => fetchFactory('/countries')

export const setCountry = (countryId) => fetchFactory('/rtv-users/select-country', {
	method: 'post',
	body: JSON.stringify({ countryId })
})

export const getCountriesWithRegion = () => fetchFactory('/countries/withRegions')